import { render, staticRenderFns } from "./addResourceSupplier.vue?vue&type=template&id=08539228"
import script from "./addResourceSupplier.vue?vue&type=script&lang=js"
export * from "./addResourceSupplier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports